<section class="tw-h-full race-final-results-section" [hidden]="hideSection" data-cy="results-screen">

  <div class="tw-w-full tw-flex tw-justify-end tw-pb-[8px]" *ngIf="raceResults && !isFetchingData">
    <!-- Replay video -->
    <ion-button class="matrix replay-video" (click)="replayVideo()">
      View Replay
    </ion-button>

    <!-- MATRIX -->
    <ion-button class="matrix" (click)="openMatrix()">
      MATRIX
    </ion-button>
  </div>

  <!-- Race final results -->
  <div #raceFinalResultsRef class="tw-overflow-y-auto" [hidden]="isFetchingData || !raceResults">

    <!-- table-result-main -->
    <table class="table-result-main tw-mt-2 tw-w-full" data-cy="tbl-top-runners">
      <thead class="">
      <tr>
        <th style="width: 35px;">Pos.</th>
        <th style="width: 273px;">Runner</th>
        <th style="width: 30px;"></th>
        <th style="width: 58px;">Win</th>
        <th style="width: 58px;">Place</th>
        <th style="width: 58px;">Show</th>
      </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of raceResults?.RaceResults?.Positions">
          <tr *ngFor="let runner of item?.Finishers; let i = index" class="tw-text-[11px]">
            <!-- <ng-container *ngFor="let runner of item?.Finishers; let i = index"> -->
            <ng-container>
              <td class="tw-text-center tw-m-auto" [attr.data-cy]="'result-pos-' + i">{{ item?.PositionId }}</td>
              <td class="tw-py-[.3rem]">
                <div>
                  <div class="tw-font-bold" [attr.data-cy]="'result-name-' + i">{{ runner?.Name }}</div>
                  <div [attr.data-cy]="'result-jockey-' + i">
                    Jockey:
                    {{ runner?.Jockey }}
                  </div>
                  <div [attr.data-cy]="'result-trainer-' + i">
                    Trainer:
                    {{
                      selectedRace?.Runners?.[(runner?.RunnerId||0) - 1]?.Entries?.[0]?.Trainer
                    }}
                  </div>
                </div>
              </td>
              <!-- <td>
                {{
                  runner && runner.EntryId
                  ? runner.RunnerId + (runner.EntryId || '')
                  : runner.RunnerId
                }}
              </td> -->
              <td class="{{ (selectedEvent?.ToteResponse?.EventDetail?.TrackType| getTrackType: true)+'-'+runner?.RunnerId }} tw-text-center" [attr.data-cy]="'result-runner-' + i">
                {{ runner?.RunnerId }}
              </td>
              <td class="tw-text-center" [attr.data-cy]="'result-win-' + i">{{ raceResults | raceResult: 'MAIN': runner||0: 'WIN' | numberWithCommas }}</td>
              <td class="tw-text-center" [attr.data-cy]="'result-plc-' + i">{{ raceResults | raceResult: 'MAIN': runner||0: 'PLC' | numberWithCommas}}</td>
              <td class="tw-text-center" [attr.data-cy]="'result-shw-' + i">{{ raceResults | raceResult: 'MAIN': runner||0: 'SHW' | numberWithCommas}}</td>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <!-- table-personal-statistics -->
    <table class="table-personal-statistics tw-mt-5 tw-w-full" data-cy="tbl-personal-stats">
      <thead class="">
        <tr>
          <th  colspan="2" >Personal Statistics</th>
        </tr>
      </thead>
      <tbody>
      <tr>
        <td class="tw-pl-2 tw-py-[.3rem]" data-cy="stat-label-wagers">Wagers</td>
        <td class="wager-cont tw-text-right tw-pr-2">
          {{ personalStatistic?.ticketCounter }}
        </td>
      </tr>
      <tr>
        <td class="tw-pl-2 tw-py-[.3rem]" data-cy="stat-label-wagered">Wagered</td>
        <td class="wager-amount tw-text-right tw-pr-2">
          ${{ personalStatistic?.ticketAmount }}
        </td>
      </tr>
      <tr>
        <td class="tw-pl-2 tw-py-[.3rem]" data-cy="stat-label-return">Return</td>
        <td class="wager-return tw-text-right tw-pr-2">
          ${{ personalStatistic?.earnings }}
        </td>
      </tr>
      <tr>
        <td class="tw-pl-2 tw-py-[.3rem]" data-cy="stat-label-profit-loss">P/L</td>
        <td class="wager-profit-loss tw-text-right tw-pr-2">
          ${{ personalStatistic?.profitLoss }}
        </td>
      </tr>
      </tbody>
    </table>

    <!-- table-result-pool -->
    <table class="table-result-pool tw-mt-5 tw-w-full" data-cy="tbl-results">
      <thead>
        <tr>
          <th class="tw-text-left tw-pl-2 tw-w-[20%]">Pool Name</th>
          <th class="tw-text-center tw-m-auto tw-w-[20%]">Finish</th>
          <th class="tw-text-center tw-m-auto tw-w-[20%]">Wager</th>
          <th class="tw-text-center tw-m-auto tw-w-[20%]">Payout</th>
          <th class="tw-text-right tw-pr-2 tw-w-[30%]">Total Pool</th>
        </tr>
      </thead>
      <tbody class="tw-text-[11px]">
        <ng-container *ngFor="let poolPrice of raceResults?.PoolPrices">
          <ng-container *ngIf="poolPrice?.Refund">
            <tr>
              <td class="tw-py-[.3rem] tw-text-left tw-pl-2">
                {{ poolPrice?.PoolName }}
              </td>
              <td class="tw-text-center tw-m-auto">Refund</td>
              <td class="tw-text-center tw-m-auto">Refund</td>
              <td class="tw-text-center tw-m-auto">Refund</td>
              <td class="tw-text-right tw-pr-2">Refund</td>
            </tr>
          </ng-container>

          <ng-container *ngIf="!poolPrice?.Refund">
            <tr *ngFor="let price of poolPrice?.Prices">
              <td class="tw-py-[.3rem] tw-text-left tw-pl-2">
                {{ poolPrice?.PoolName }}
              </td>
              <td class="tw-text-center tw-m-auto">
                {{ price?.Finish | numberWithCommas }}
              </td>
              <td class="tw-text-center tw-m-auto">
                {{
                  price?.Wager
                    ? '$ ' + (price?.Wager | numberWithCommas)
                    : price?.Wager
                }}
              </td>
              <td class="tw-text-center tw-m-auto">
                {{
                  price?.PriceAmount
                    ? '$ ' + (price?.PriceAmount | numberWithCommas)
                    : price?.PriceAmount
                }}
              </td>
              <td class="tw-text-right tw-pr-2">
                {{
                  poolsTotal | raceResult: 'POOL': poolPrice||0 | numberWithCommas
                }}
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <tr class="tw-font-bold">
          <td colspan="2" class="tw-py-[.3rem] tw-text-left tw-pl-2">
            Race Handle
          </td>
          <td colspan="3" class="tw-text-right tw-pr-2">
            {{ '$ ' + totalHandle?.toFixed()| numberWithCommas }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- table-result-pool-total -->
    <table class="table-result-pool-total" hidden>
      <tbody>
      <tr>
          <td>-</td>
          <td>-</td>
      </tr>
      </tbody>
    </table>

    <!-- table-result-scratches -->
    <div class="table-result-scratches tw-mt-5 tw-pb-[10px]">
      <p>Scratches</p>

      <ng-container *ngIf="raceResults?.RaceResults?.Scratches">
        <div class="tw-w-full tw-flex" *ngFor="let item of (raceResults?.RaceResults?.Scratches | stringToArrary)">
          <div
            class="
              tw-text-center
              tw-w-[40px]
              tw-py-[.3rem]
              {{ (selectedEvent?.ToteResponse?.EventDetail?.TrackType| getTrackType: true)+'-'+item }}
            ">
            {{ item }}
          </div>
          <div class="tw-px-2 tw-text-[11px] tw-capitalize tw-py-[.3rem]">
            {{ (selectedRace?.Runners | getRunner: item)?.Name }}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!raceResults?.RaceResults?.Scratches">
        No Scratches
      </ng-container>

    </div>

  </div>

  <div *ngIf="isFetchingData">
    <p>
      Getting the results. Please wait...
    </p>
  </div>

  <div *ngIf="!raceResults && isFetchingData===false">
    <p>
      No Results found
    </p>
  </div>
</section>
